<template>
	<div :class="['aselect', options.className]">
		<div class="selector" @click="toggle" v-closable="{ exclude: ['button'], handler: 'onClose' }">
			<div v-if="options.icon" class="arrow"></div>
			<button class="label" :disabled="getLoading">
				<span v-if="value && options.isOrder">{{ value }}</span>
				<span v-else>{{ options.value }}</span>
			</button>
			<div :class="{ hidden: !visible, visible }">
				<ul>
					<li
						:class="{ current: item.label === value, selected: getSelectedOffers.includes(item.offer) }"
						v-for="(item, index) in options.list"
						:key="index"
						@click="select($event, item)"
					>
						{{ item.label }}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
	data() {
		return {
			visible: false,
			value: null,
		};
	},
	props: {
		options: { type: Object, default: () => {} },
	},
	computed: {
		...mapGetters(['getSelectedOffers', 'getLoading']),
	},
	methods: {
		...mapMutations(['setSelectedOffer']),
		toggle() {
			if (!this.getLoading) {
				this.visible = !this.visible;
			}
		},
		select(e, option) {
			if (!this.options.isOrder) {
				if (this.getSelectedOffers.length < 2) {
					e.stopPropagation();
				}

				this.setSelectedOffer(option.offer);

				if (this.getSelectedOffers.length == 2) {
					this.$router.push({ name: 'comparing-two-offers', params: { hash: this.$route.params.hash } });
				}
			} else {
				this.value = option.label;
				this.$emit('orderBy', option);
			}
		},
		onClose() {
			this.visible = false;
		},
	},
};
</script>
